import React from 'react';
import classes from 'new/components/settings/VendorBuilder/VendorBuilder.module.scss';
import { Stack } from '@mui/material';
import Typography from 'new/elements/Typography';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { Button } from 'new/elements/Button';
import { Close as CloseIcon } from '@mui/icons-material';

type ErrorsProps = {
  onClose: () => void;
};

const Error = ({ label, value }) => {
  return (
    <Stack className={classes.errorContainer}>
      <Typography variant="body1">{label}</Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
};

export const Errors = (props: ErrorsProps) => {
  const { errors } = useVendorBuilder();
  return (
    <Stack className={classes.errorsContainer}>
      <Button onClick={props.onClose} color="inherit" startIcon={<CloseIcon />}>
        Close
      </Button>
      <Typography padding="16px">
        Uh-oh! Looks like there are some validation errors in your spec. Please fix the errors
        before submitting.
        <br />
        <br />
        <strong>Please note:</strong>
        <br />
        It is possible there are some false alarms in the validator. <br />
        If you had clicked <code>Copy to Clipboard</code> your spec has been copied to the
        clipboard. If you feel the spec is ok, please continue submitting to GitHub PR.
        <br />
      </Typography>
      {Object.keys(errors).map((key) => {
        return <Error key={key} label={key} value={errors[key]} />;
      })}
    </Stack>
  );
};
